module.exports = __webpack_public_path__ + "img/cave97.350673d5.jpg";